import { render, staticRenderFns } from "./BlackBookAnalysis.vue?vue&type=template&id=548091bc&scoped=true"
import script from "./BlackBookAnalysis.vue?vue&type=script&lang=js"
export * from "./BlackBookAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BlackBookAnalysis.vue?vue&type=style&index=0&id=548091bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548091bc",
  null
  
)

export default component.exports